const textFieldStyle = { flex: 1, marginTop: 8, marginBottom: 8 };
const autocompleteStyle = { flex: 1 };
const compactStyle = { margin: 0 };

export { textFieldStyle, autocompleteStyle, compactStyle };
